import { StrictMode } from 'react';
import { App } from './App';
import './index.css';
import { initializeSentry } from './utils/sentry';
import { initializePostHog, posthog } from './utils/analytics';
import { createRoot } from 'react-dom/client';
import { PostHogProvider } from 'posthog-js/react';
import { ConvexAuthProvider } from '@convex-dev/auth/react';
import { ConvexReactClient } from 'convex/react';
import { ConvexAvailableProvider } from './contexts/ConvexAvailableContext';

// Initialize analytics and monitoring
initializePostHog();
initializeSentry();

const convexUrl = import.meta.env.VITE_CONVEX_URL as string | undefined;
const convex = convexUrl ? new ConvexReactClient(convexUrl) : null;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <ConvexAvailableProvider value={!!convex}>
        {convex ? (
          <ConvexAuthProvider client={convex}>
            <App />
          </ConvexAuthProvider>
        ) : (
          <App />
        )}
      </ConvexAvailableProvider>
    </PostHogProvider>
  </StrictMode>
);
